import { gql } from "@apollo/client";

export interface Applicant {
  id: string;
  person: {
    id: string;
    firstName: string;
    lastName: string;
  };
}
export interface ApplicantData {
  job: {
    applicants: {
      nodes: Applicant[];
    };
  };
}

export const GET_MANAGEABLE_SECTIONS = gql`
  query GetManageableSections($input: BackofficeManageableSectionsInput!) {
    manageableSections(input: $input) {
      nodes {
        id
        name
        legacyId
      }
    }
  }
`;

export const GET_JOB_APPLICANTS = gql`
  query GetJobApplicants($id: ID!) {
    jobPost(id: $id) {
      id
      applications {
        id
        appliedOn
        resume
        applicant {
          id
          firstName
          lastName
          pgaId
          latestProgram {
            id
            programType {
              id
              name
            }
          }
          primarySection {
            id
            name
          }
          profilePhoto
          displayName
        }
      }
    }
  }
`;

export const SLACK_USER_QUERY = gql`
  query GetSlackUser($email: String!) {
    slackUser(email: $email) {
      id
    }
  }
`;

export const SEND_SLACK_REVIEW_REQUEST_MUTATION = gql`
  mutation PostApplicationReviewRequest(
    $reviewerIds: [String!]
    $message: String
    $applicationsUrl: String!
    $jobPostId: ID
  ) {
    postApplicationReviewRequest(
      reviewerIds: $reviewerIds
      message: $message
      applicationsUrl: $applicationsUrl
      jobPostId: $jobPostId
    ) {
      success
      message
    }
  }
`;
